import { LANGUAGE_MAP } from './enum'

export const getLang = (text: string) => {
  const lg = localStorage.getItem('language') || 'zh-cn';

  return LANGUAGE_MAP?.[lg]?.[text] || ''
}
